/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react'
import styled from 'styled-components'
import type {ILoader} from './types'
import S from './styles/loader.styles'

// Overlay container for showing loader on top of content
const OverlayContainer = styled.div`
  position: relative;
`

const OverlayBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: inherit;
`

interface LoadingBoundaryProps extends ILoader {
  /**
   * When true, shows the loader as an overlay on top of children
   * instead of replacing them. Children remain visible but dimmed.
   */
  overlay?: boolean
}

export function LoadingBoundary({
  children,
  isLoading,
  size = 'medium',
  positioned = 'absolute',
  page,
  overlay = false,
  'data-testid': dataTestId = 'loader',
  ...props
}: LoadingBoundaryProps) {
  // Overlay mode: show children with loader on top
  if (overlay) {
    return (
      <OverlayContainer>
        {React.Children.map(
          children,
          (child) => React.isValidElement(child) && React.cloneElement(child, {...props}),
        )}
        {isLoading && (
          <OverlayBackdrop data-testid="loading-overlay">
            <S.Loader
              data-testid="isLoadingSpinner"
              {...props}
              positioned="relative"
              size={size}
              className="main"
            />
          </OverlayBackdrop>
        )}
      </OverlayContainer>
    )
  }

  // Default mode: replace children with loader
  return isLoading === true ? (
    <S.Loader
      data-testid="isLoadingSpinner"
      {...props}
      // hardcoded to absolute for now
      positioned="absolute"
      size={size}
      className="main"
    />
  ) : (
    <>
      {React.Children.map(
        children,
        (child) => React.isValidElement(child) && React.cloneElement(child, {...props}),
      )}
    </>
  )
}

